export const SET_CURRENT_USER = "SET_CURRENT_USER"
export const SET_CURRENT_USER_ROLE = 'SET_CURRENT_USER_ROLE';

